import React, { useEffect, useRef } from "react";
import prev from '../../images/caret-left.svg';
import next from '../../images/caret-right.svg';
import { ProgressSpinner } from "primereact/progressspinner";

export function Images({ styles, setImageSelecionada, imageSelecionada, jobImageSelecionado, isLoadingImages }) {

    const refs = useRef([]);

    useEffect(() => {
        if (refs.current[imageSelecionada]) {
            refs.current[imageSelecionada].current.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'start'
            });
        }
    }, [imageSelecionada]);

    useEffect(() => {
        refs.current = jobImageSelecionado.map((_, index) => refs.current[index] || React.createRef());
    }, [jobImageSelecionado]);

    function prevImage() {
        if (imageSelecionada) {
            setImageSelecionada(prevIndex => (prevIndex - 1 + jobImageSelecionado.length) % jobImageSelecionado.length);
        }
    }

    function nextImage() {
        if (imageSelecionada < jobImageSelecionado.length - 1) {
            setImageSelecionada(prevIndex => (prevIndex + 1) % jobImageSelecionado.length);
        }
    }

    if (isLoadingImages) {
        return (
            <div className={`${styles.image} ${styles.imagesLoading}`}>
                <ProgressSpinner />
            </div>
        );
    }

    return (
        <div className={styles.image}>
            <div className={styles.selectedImage}>
                {jobImageSelecionado.length > 1 && <ButtonGaleria src={prev} fn={() => prevImage()} disabled={imageSelecionada === 0} />}
                <img src={`data:image/png;base64, ${jobImageSelecionado[imageSelecionada]?.ImageBase64}`} />
                <p>{jobImageSelecionado[imageSelecionada]?.FileName}</p>
                {jobImageSelecionado.length > 1 && <ButtonGaleria src={next} fn={() => nextImage()} disabled={imageSelecionada === jobImageSelecionado.length - 1} />}
            </div>
            <hr />
            <div className={styles.imgContainer}>
                <div className={styles.imagesList}>
                    {jobImageSelecionado.map((image, index) => (
                        <div key={index} className={`${styles.box} ${imageSelecionada === index ? styles.boxSelected : ''}`} onClick={() => setImageSelecionada(index)}>
                            <img ref={refs.current[index]} src={`data:image/png;base64, ${image.ImageBase64}`} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

function ButtonGaleria({ src, fn }) {
    return (
        <button onClick={fn}>
            <img src={src} width={24} />
        </button>
    );
}